// extracted by mini-css-extract-plugin
module.exports = {"leftIconWrapper":"_1xJpb","rightIconWrapper":"_2r7zQ","leftClickArea":"_2iLSj","rightClickArea":"_1k1M-"};